import { createContext, useContext } from 'react'

type ShortChapterContextType = {
  openShortChapter: (slug: string) => void
}

export const ShortChapterContext = createContext<ShortChapterContextType>({
  openShortChapter: () => {},
})

export function useShortChapter() {
  return useContext(ShortChapterContext)
}
